
import React from 'react'
import icon from './svgs/flesh.svg'
import { BaseIcon } from './_base'

export const FleshIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
